import { faDownload as DownloadIcon } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FormControl,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useSourceDialog } from '../SourceCreate.hooks';
import { downloadCertificate } from '../SourceCreate.service';
import { sourceResponseAtom } from '../SourceCreate.store';
import useStyles from '../SourceCreate.styles';
import { SourceDialogMode } from '../SourceCreate.types';

const AddThumbprintId = () => {
  const { mode: themeMode } = useColorScheme();
  const { classes } = useStyles({ themeMode });
  const { register, setValue, formState } = useFormContext();
  const { errors } = formState;
  const { mode } = useSourceDialog();
  const [sourceResponse] = useAtom(sourceResponseAtom);

  useEffect(() => {
    if (sourceResponse?.source_uid) {
      setValue('source_uid', sourceResponse.source_uid);
      setValue('source_name', sourceResponse.source_name || '');
    }
  }, [setValue, sourceResponse]);

  const downladCertificate = () => {
    downloadCertificate(sourceResponse?.source_uid || '');
  };
  function getMessage() {
    if (mode === SourceDialogMode.New) {
      return 'The service will remain inactive until the Thumbprint ID is provided. The Thumbprint ID can also be provided later using the Edit option in the respective service.';
    }
    return 'The service will continue as is using the old certificate & Thumbprint ID provided both of them are valid. The Thumbprint ID can also be provided later using the Edit option in the respective service.';
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 12 }}>
        <Typography>
          <strong>Step 1</strong>- The certificates will be downloaded
          automatically. If not, use the below Button to download:
        </Typography>
        <Grid
          style={{ marginTop: '.8rem', marginBottom: '.8rem' }}
          size={{ md: 4 }}
        >
          <FormControl className={classes.widthFull}>
            <Stack direction="row">
              <TextField
                className={classes.downloadRefreshFile}
                slotProps={{ input: { readOnly: true } }}
                placeholder="Certificate Files"
              />
              <IconButton
                className={classes.choseFileBtn}
                onClick={() => downladCertificate()}
              >
                <FontAwesomeIcon icon={DownloadIcon} size="sm" />
              </IconButton>
            </Stack>
          </FormControl>
        </Grid>
        <Typography>
          <strong>Step 2</strong>
          Upload the certificate in the Customers Microsoft Azure AD application
          that we are trying to connect
        </Typography>
        <ol>
          <li>
            <strong>Login in to the respective Azure AD</strong>
          </li>
          <li>
            <strong>
              {
                'Navigate to All Services -> Overview -> App Registrations -> <Select the Client Application created> -> Certificates & Secrets'
              }
            </strong>
          </li>
          <li>
            <strong>
              Upload the certificate using Upload Certificate option
            </strong>
          </li>
        </ol>

        <Typography>
          <strong>Step 3</strong>- Please provide the Thumbprint ID in the below
          text box which was generated when the certificate was uploaded in Step
          2.
        </Typography>
        <Grid style={{ marginTop: '.8rem' }} size={{ md: 4 }}>
          <FormControl className={classes.widthFull}>
            <Stack direction="row">
              <TextField
                type="password"
                className={classes.widthFull}
                {...register('thumbprint_id', {
                  required: 'ThumbprintId is required'
                })}
                placeholder="Enter Thumbprint ID"
                error={!!errors?.thumbprint_id}
              />
              <TextField
                type="hidden"
                {...register('source_uid')}
                style={{ display: 'none' }}
              />
              <TextField
                type="hidden"
                {...register('source_name')}
                style={{ display: 'none' }}
              />
            </Stack>
          </FormControl>
        </Grid>

        <Grid size={{ md: 12 }} sx={{ my: 2 }}>
          <Stack direction="row">
            <div>
              <i className="fas fa-info-circle text-primary me-2" />
            </div>
            <div>
              <p>{getMessage()}</p>
            </div>
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddThumbprintId;
